import { DELETE, POST_MULTIPART } from "@/services/api";
import { API_ROUTES } from "@/services/environment";
import axios, { AxiosResponse } from "axios";

const { bsnsUploadImg, uploadFileApi, deleteFileApi, uploadResourceFileApi, uploadCampaignImageApi } = API_ROUTES;

// Reusable file upload function
export const s3UploadFile = async (
  file: any,
  refreshToken: string
): Promise<AxiosResponse<any>> => {
  try {
    const res = await POST_MULTIPART(uploadFileApi, { file }, refreshToken);
    return res;
  } catch (error) {
    console.log("File upload failed:", error);
    throw error; // Rethrow the error to handle it outside the function
  }
};

// Uploads a file into the resources/ S3 folder (used by the Resources page)
export const s3UploadResourceFile = async (
  file: any,
  refreshToken: string
): Promise<AxiosResponse<any>> => {
  try {
    const res = await POST_MULTIPART(uploadResourceFileApi, { file }, refreshToken);
    return res;
  } catch (error) {
    console.log("Resource file upload failed:", error);
    throw error; // Rethrow the error to handle it outside the function
  }
};

// Uploads a file into the campaigns/ S3 folder (used by the Add/Edit Campaign form)
export const s3UploadCampaignImage = async (
  file: any,
  refreshToken: string
): Promise<AxiosResponse<any>> => {
  try {
    const res = await POST_MULTIPART(uploadCampaignImageApi, { file }, refreshToken);
    return res;
  } catch (error) {
    console.log("Campaign image upload failed:", error);
    throw error; // Rethrow the error to handle it outside the function
  }
};

export const s3DeleteFile = async (
  url: any,
  refreshToken: string,
  data?: { businessId: string; imageType: 'logo'|'videos'|'primary'|'portfolio'; remainingUrls: string[]|null }|null
): Promise<AxiosResponse<any>> => {
  try {
    const res = await DELETE(deleteFileApi, refreshToken, { url, data });

    return res;
  } catch (error) {
    console.log("File upload failed:", error);
    throw error; // Rethrow the error to handle it outside the function
  }
};
